<svg 
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink"
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 14 14">
    <path d="M14 7q0 0.203-0.148 0.352l-2 2q-0.148 0.148-0.352 0.148t-0.352-0.148-0.148-0.352v-1h-3v3h1q0.203 0 0.352 0.148t0.148 0.352-0.148 0.352l-2 2q-0.148 0.148-0.352 0.148t-0.352-0.148l-2-2q-0.148-0.148-0.148-0.352t0.148-0.352 0.352-0.148h1v-3h-3v1q0 0.203-0.148 0.352t-0.352 0.148-0.352-0.148l-2-2q-0.148-0.148-0.148-0.352t0.148-0.352l2-2q0.148-0.148 0.352-0.148t0.352 0.148 0.148 0.352v1h3v-3h-1q-0.203 0-0.352-0.148t-0.148-0.352 0.148-0.352l2-2q0.148-0.148 0.352-0.148t0.352 0.148l2 2q0.148 0.148 0.148 0.352t-0.148 0.352-0.352 0.148h-1v3h3v-1q0-0.203 0.148-0.352t0.352-0.148 0.352 0.148l2 2q0.148 0.148 0.148 0.352z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-arrows.html